import React from 'react'

const CopyRights = () => {
    return (
        <div className='p-4 bg-gradient-to-t from-gray-900 to-gray-800 flex justify-center items-center text-white font-light text-sm tracking-wide w-full'>
            All Rights Reserved to Mr.RoboT
        </div>
    )
}

export default CopyRights